import * as types from "_graphql-types/graphql";
import { Tag } from "frontend/src/components/Tag/Tag";
import { removeFilter } from "Reducers/globalSearchV2/globalSearchV2.actions";
import { useDispatch } from "src/react-redux";

export interface Props {
  filter: types.SharedContentFilter;
}

function label(mode: types.SharedContentMode | null | undefined) {
  if (mode === types.SharedContentMode.ExcludeShared) return "Shared hidden";
  if (mode === types.SharedContentMode.OnlyShared) return "Only shared";
  return null;
}

export default function SharedContentFilterTag({ filter }: Props) {
  const dispatch = useDispatch();

  const text = label(filter?.mode);
  if (!text) return null;

  return (
    <Tag
      className="ant-tag--blue ant-tag--close"
      data-cy="shared-content-filter-tag"
      onClose={() => {
        dispatch(
          removeFilter({
            type: "investment",
            data: {
              type: "investment",
              data: {
                type: "SHARED_CONTENT",
                data: filter,
              },
            },
          })
        );
      }}
      closable
    >
      {text}
    </Tag>
  );
}
